module.exports = __webpack_public_path__ + "static/media/mail.d7bbdd5d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/mail.svg
// module id = 1284
// module chunks = 1